import { StatusEnum } from "./status-enum";

export const statusColors = {
  [StatusEnum.RECEIVED]: "default",
  [StatusEnum.PARTIALLY_INVOICED]: "warning",
  [StatusEnum.FULLY_INVOICED]: "success",
};
